import Text from './text'
import { TextSizes, TextWeights } from './constants'

export { TextSizes, TextWeights }

export default Text
